/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SaleOrder,
} from '../models/index';
import {
    SaleOrderFromJSON,
    SaleOrderToJSON,
} from '../models/index';

export interface GetSaleOrderByCompanyIdRequest {
    companyId: number;
}

export interface GetSaleOrderByOpportunityIdRequest {
    opportunityId: number;
}

export interface GetSaleOrderByUserIdAndPartnerIdRequest {
    userId: number;
    partnerId: number;
}

/**
 * 
 */
export class SaleOrderApi extends runtime.BaseAPI {

    /**
     * Get saleOrders by companyId
     */
    async getSaleOrderByCompanyIdRaw(requestParameters: GetSaleOrderByCompanyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SaleOrder>>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling getSaleOrderByCompanyId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/sale-order/company/{companyId}`;
        urlPath = urlPath.replace(`{${"companyId"}}`, encodeURIComponent(String(requestParameters['companyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SaleOrderFromJSON));
    }

    /**
     * Get saleOrders by companyId
     */
    async getSaleOrderByCompanyId(requestParameters: GetSaleOrderByCompanyIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SaleOrder>> {
        const response = await this.getSaleOrderByCompanyIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get saleOrders by opportunityId
     */
    async getSaleOrderByOpportunityIdRaw(requestParameters: GetSaleOrderByOpportunityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SaleOrder>>> {
        if (requestParameters['opportunityId'] == null) {
            throw new runtime.RequiredError(
                'opportunityId',
                'Required parameter "opportunityId" was null or undefined when calling getSaleOrderByOpportunityId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/sale-order/opportunity/{opportunityId}`;
        urlPath = urlPath.replace(`{${"opportunityId"}}`, encodeURIComponent(String(requestParameters['opportunityId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SaleOrderFromJSON));
    }

    /**
     * Get saleOrders by opportunityId
     */
    async getSaleOrderByOpportunityId(requestParameters: GetSaleOrderByOpportunityIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SaleOrder>> {
        const response = await this.getSaleOrderByOpportunityIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get saleOrders by userId and PartnerId
     */
    async getSaleOrderByUserIdAndPartnerIdRaw(requestParameters: GetSaleOrderByUserIdAndPartnerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SaleOrder>>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getSaleOrderByUserIdAndPartnerId().'
            );
        }

        if (requestParameters['partnerId'] == null) {
            throw new runtime.RequiredError(
                'partnerId',
                'Required parameter "partnerId" was null or undefined when calling getSaleOrderByUserIdAndPartnerId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/sale-order/user/{userId}/{partnerId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"partnerId"}}`, encodeURIComponent(String(requestParameters['partnerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SaleOrderFromJSON));
    }

    /**
     * Get saleOrders by userId and PartnerId
     */
    async getSaleOrderByUserIdAndPartnerId(requestParameters: GetSaleOrderByUserIdAndPartnerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SaleOrder>> {
        const response = await this.getSaleOrderByUserIdAndPartnerIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
